module.exports = __webpack_public_path__ + "03_long_gold.b3e9622d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_long_gold.png
// module id = gBFU
// module chunks = 0